import { render, staticRenderFns } from "./ListPrice.vue?vue&type=template&id=b0044b08&scoped=true"
import script from "./ListPrice.vue?vue&type=script&lang=js"
export * from "./ListPrice.vue?vue&type=script&lang=js"
import style0 from "./ListPrice.vue?vue&type=style&index=0&id=b0044b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0044b08",
  null
  
)

export default component.exports